import { useEffect, type FC } from "react";
import { useChatContext } from "duck/ui/chat/contexts/useChatContext";

import type { ActionHandlerProps } from "./types";

export const FollowupQuestionsAction: FC<ActionHandlerProps> = ({ action }) => {
  const { setFollowupQuestionsEnabled } = useChatContext();

  useEffect(() => {
    if (action.type === "followup_questions") {
      setFollowupQuestionsEnabled(action.is_enabled);
    }
  }, [action, setFollowupQuestionsEnabled]);

  return null;
};
